import type { SimilarDayMatch } from '@/types/patterns';

const TIME_PERIOD_LABELS = {
  morning: 'morning',
  midday: 'midday',
  evening: 'evening',
} as const;

interface SimilarDayInsightProps {
  match: SimilarDayMatch;
}

export function SimilarDayInsight({ match }: SimilarDayInsightProps) {
  const {
    waypointName,
    totalSimilarEntries,
    entriesWithObservation,
    matchedConditions,
    sampleSize,
  } = match;

  const conditionsSummary = [
    matchedConditions.tempRange,
    `pressure ${matchedConditions.pressureTrend}`,
    TIME_PERIOD_LABELS[matchedConditions.timePeriod],
  ].join(', ');

  return (
    <div
      className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg p-3"
      data-testid="similar-day-insight"
    >
      <p className="field-label mb-2">
        Your History at {waypointName}
      </p>
      <p className="text-body-sm text-[var(--color-text-primary)]">
        On {totalSimilarEntries} similar {totalSimilarEntries === 1 ? 'day' : 'days'} ({conditionsSummary}), you observed deer{' '}
        <span className="font-semibold text-[var(--color-accent)]">
          {entriesWithObservation} out of {totalSimilarEntries}
        </span>{' '}
        {totalSimilarEntries === 1 ? 'time' : 'times'}.
      </p>
      <p className="text-body-xs text-[var(--color-text-placeholder)] mt-1.5" data-testid="sample-size">
        Based on {sampleSize} scouting {sampleSize === 1 ? 'visit' : 'visits'}
      </p>
    </div>
  );
}
